import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { isEmpty } from '../../utils/lodashUtils';
import { CircularProgress } from '../../utils/materialUI';
import { Col, Row } from '../../utils/bootstrapUtils';
import '../../assets/styles/AdvanceSearch.css';
import { Input } from '../common';
import { listFatwas, listCriteriaFilteredFatwas, listKeywordFilteredFatwas } from '../../actions/FatwaActions';
import CategorySelect from '../common/CategorySelect';
import { ADVANCED_SEARCH_FORM } from '../../utils/constants';
import Routes from '../../constants/routes';
import Fatwas from '../FatwasList/Fatwas';
import { computeOffsetFromPageNo, extractParamsFromUrl, scrollToElementWithAnimation } from '../../utils/utils';
import { FATWAS_PER_PAGE } from '../../constants/globals';

const { questionMaxLength, titleMaxLength, answerMaxLength } = ADVANCED_SEARCH_FORM;

class AdvanceSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultCategoryId: '',
            selectedCategory: '',
            categoryId: '',
            fatwaId: '',
            question: '',
            title: '',
            answer: '',
            disableSearchButton: false,
        };
    }

    componentDidMount() {
        document.title = 'Advanced Search » Askimam';
        this.getFatwas();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.path !== this.props.match.path) {
            this.getFatwas();
        }
    }

    handlePageClick = (data) => {
        const pageNo = data.selected + 1;

        const params = extractParamsFromUrl();
        params.page = pageNo;

        this.getFatwas(pageNo);
        scrollToElementWithAnimation('fatwas-list');

        this.props.history.push({
            pathname: window.location.pathname,
            search: Object.keys(params).length > 0 ? `?${queryString.stringify(params)}` : '',
        });
    };

    isAdvanceFilterApplied = (params) => {
        const {
            categoryId, fatwaId, question, title, answer,
        } = params;
        return categoryId || fatwaId || question || title || answer;
    }

    getFatwas = (pageNo) => {
        const { searchBarKeyword } = this.props;
        const params = extractParamsFromUrl();
        const {
            categoryId = '', fatwaId = '', question = '', title = '', answer = '', page = 1,
        } = params;

        const offset = computeOffsetFromPageNo(pageNo || page, FATWAS_PER_PAGE);
        const isAdvanceSearch = window.location.pathname.includes(Routes.advanceSearch);

        if (isAdvanceSearch) {
            const newState = {
                defaultCategoryId: categoryId,
                categoryId,
                fatwaId,
                question,
                title,
                answer,
            };

            if (this.isAdvanceFilterApplied(params)) {
                newState.disableSearchButton = false;
                this.props.listCriteriaFilteredFatwas(categoryId, fatwaId, question, title, answer, offset);
            } else {
                newState.disableSearchButton = true;
                this.props.listFatwas(0, offset);
            }
            this.setState(newState);
        } else if (searchBarKeyword) {
            this.props.listKeywordFilteredFatwas(searchBarKeyword, offset);
        }
    }

    handleCategoryChange = (selectedCategory) => {
        this.setState(
            {
                selectedCategory,
                categoryId: selectedCategory.value,
                defaultCategoryId: '',
                disableSearchButton: false,
            },
        );
    };

    handleChange = (data) => {
        data.preventDefault();
        const name = data.target.name;
        this.setState({ [name]: data.target.value }, () => this.setSearchButtonState());
    };

    setSearchButtonState = () => {
        const {
            question, title, answer, categoryId, fatwaId,
        } = this.state;
        const isQueryEntered = (question && question.length > 0)
                                || (title && title.length > 0)
                                || (answer && answer.length > 0)
                                || (categoryId && categoryId.length > 0)
                                || (fatwaId && fatwaId.length > 0);

        this.setState({
            disableSearchButton: !isQueryEntered,
        });
    };

    handleSubmit = () => {
        const offset = computeOffsetFromPageNo(1, FATWAS_PER_PAGE);

        const {
            categoryId, fatwaId, question, title, answer,
        } = this.state;

        if (!categoryId || !isEmpty(fatwaId) || !isEmpty(question) || !isEmpty(title) || !isEmpty(answer)) {
            this.props.listCriteriaFilteredFatwas(categoryId, fatwaId, question, title, answer, offset);

            let params = `?question=${question ? escape(question) : ''}`;
            params += `&title=${title ? escape(title) : ''}`;
            params += `&answer=${answer ? escape(answer) : ''}`;
            params += `&categoryId=${categoryId ? escape(categoryId) : ''}`;
            params += `&fatwaId=${fatwaId ? escape(fatwaId) : ''}`;
            params += '&page=1';

            this.props.history.push({
                pathname: Routes.advanceSearch,
                search: encodeURI(params),
            });
        }
    };

    resetForm = (form) => {
        const newState = {
            fatwaId: '',
            question: '',
            title: '',
            answer: '',
            disableSearchButton: true,
        };

        if (form.id === 'criteria-search') {
            newState.selectedCategory = null;
            newState.categoryId = '';
            newState.defaultCategoryId = '';
        }
        newState.disableSearchButton = true;

        this.setState(newState);
        this.props.listFatwas(0, 0);
        this.props.history.push(Routes.advanceSearch);
    };

    setDocumentTitle = (isAdvanceSearch) => {
        document.title = `${isAdvanceSearch ? 'Advanced ' : 'Basic '} Search » Askimam`;
    };

    render() {
        const { fatwas = [], isLoading } = this.props.listFatwasReducer;
        const isAdvanceSearch = window.location.pathname.includes(Routes.advanceSearch);
        this.setDocumentTitle(isAdvanceSearch);

        const params = extractParamsFromUrl();
        const page = params?.page || 1;

        return (
            <div>
                {
                    isAdvanceSearch ?
                        <Row id="search">
                            <div className="search-heading"><h1>Advanced Search</h1></div>
                            <Col lg={7} id="criteria-search">
                                <div className="info-container">
                                    <Input
                                        type="text"
                                        label="Question"
                                        name="question"
                                        handleChange={this.handleChange}
                                        value={this.state.question}
                                        icon="fa-question"
                                        maxLength={questionMaxLength}
                                    />
                                    <span>Characters Count: {this.state.question ? this.state.question.length : 0}/{questionMaxLength}</span>
                                </div>
                                <div className="info-container">
                                    <Input
                                        type="text"
                                        label="Title"
                                        name="title"
                                        handleChange={this.handleChange}
                                        value={this.state.title}
                                        icon="fa-header"
                                        maxLength={titleMaxLength}
                                    />
                                    <span>Characters Count: {this.state.title ? this.state.title.length : 0}/{titleMaxLength}</span>
                                </div>
                                <div className="info-container">
                                    <Input
                                        type="text"
                                        label="Answer"
                                        name="answer"
                                        handleChange={this.handleChange}
                                        value={this.state.answer}
                                        icon="fa-reply"
                                        maxLength={answerMaxLength}
                                    />
                                    <span>Characters Count: {this.state.answer ? this.state.answer.length : 0}/{answerMaxLength}</span>
                                </div>
                                <CategorySelect
                                    handleCategoryChange={this.handleCategoryChange}
                                    selectedCategory={this.state.selectedCategory}
                                    defaultCategoryId={this.state.defaultCategoryId}
                                />
                                <Input
                                    type="text"
                                    label="Fatwa Number"
                                    name="fatwaId"
                                    handleChange={this.handleChange}
                                    value={this.state.fatwaId}
                                    icon="fa-list-ol"
                                />
                                <div className="button-holder">
                                    <button
                                        type="button"
                                        className="submit button"
                                        onClick={this.handleSubmit}
                                        disabled={isLoading || this.state.disableSearchButton}
                                    >Search
                                    </button>
                                    <button
                                        type="button"
                                        className="reset button"
                                        onClick={() => {
                                            const form = document.getElementById('criteria-search');
                                            this.resetForm(form);
                                        }}
                                        disabled={isLoading || this.state.disableSearchButton}
                                    >Reset
                                    </button>
                                </div>
                            </Col>
                            {
                                isLoading ?
                                    <Col lg={5}>
                                        <div className="loader"><CircularProgress /></div>
                                    </Col>
                                    : ''
                            }
                        </Row>
                        : ''
                }
                <div>
                    <Fatwas
                        heading="Filtered Fatawa"
                        isLoading={isLoading}
                        fatwas={fatwas}
                        currentPage={page}
                        isAdvanceSearchForm={isAdvanceSearch}
                        handlePageClick={this.handlePageClick}
                    />
                </div>
            </div>
        );
    }
}

AdvanceSearch.defaultProps = {
    listFatwasReducer: {},
    searchBarKeyword: '',
};

AdvanceSearch.propTypes = {
    searchBarKeyword: PropTypes.string,
    history: PropTypes.object.isRequired,
    listFatwasReducer: PropTypes.object,
    listCriteriaFilteredFatwas: PropTypes.func.isRequired,
    listKeywordFilteredFatwas: PropTypes.func.isRequired,
    listFatwas: PropTypes.func.isRequired,
};

const mapStateToProps = ({ listFatwasReducer, searchBarReducer }) => ({
    listFatwasReducer,
    searchBarKeyword: searchBarReducer.keyword,
});

export default connect(mapStateToProps, { listCriteriaFilteredFatwas, listKeywordFilteredFatwas, listFatwas })(AdvanceSearch);
